import { CountUp } from "countup.js";

export function counter() {
    const isDesktop = !this.isTouch;
    if(isDesktop) {
        const _document = this._document;
        const numbersWrap = _document.querySelector(".circles-section");
        const numbers = numbersWrap.querySelectorAll(".circle-block .value");
        
        [...numbers].forEach((num) => {
            let options = {
                separator: " ",
                duration: 7
            };
            let numData = num.textContent.replace(/\s/g, "").replace(/\,/g, ".");
            
            if(numData.indexOf(".") > -1) {
                options = { 
                    decimalPlaces: 3,
                    decimal: ",",
                    duration: 5
                };
            }
            numData = +numData;
            var countUp = new CountUp(num, numData, options);
            countUp.start();
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/counter.js